import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import ArrowRight from '@gef-ui/material-icons/ArrowRight';
import PersonSolid from '@gef-ui/material-icons/PersonSolid';

export const SemaphoreTableHead = () => {
	const iconFontSize = {
		fontSize: 28,
	};

	return (
		<TableRow>
			<TableCell sx={{ borderBottom: 'unset' }}>
				<Stack
					sx={{
						alignItems: 'center',
					}}
				>
					<PersonSolid sx={{ color: 'success.main', ...iconFontSize }} />
				</Stack>
			</TableCell>
			<TableCell sx={{ borderBottom: 'unset' }}>
				<Stack
					direction="row"
					sx={{
						justifyContent: 'center',
					}}
				>
					<ArrowRight sx={{ color: 'warning.main', ...iconFontSize }} />
					<PersonSolid sx={{ color: 'warning.main', ...iconFontSize }} />
				</Stack>
			</TableCell>
			<TableCell sx={{ borderBottom: 'unset' }}>
				<Stack
					direction="row"
					sx={{
						justifyContent: 'center',
					}}
				>
					<ArrowRight sx={{ color: 'error.main', ...iconFontSize }} />
					<PersonSolid sx={{ color: 'error.main', ...iconFontSize }} />
				</Stack>
			</TableCell>
			<TableCell sx={{ borderBottom: 'unset' }}>
				<Stack
					direction="row"
					sx={{
						justifyContent: 'center',
					}}
				>
					<ArrowRight sx={{ color: 'grey.700', ...iconFontSize }} />
					<PersonSolid sx={{ color: 'grey.700', ...iconFontSize }} />
				</Stack>
			</TableCell>
		</TableRow>
	);
};

export default SemaphoreTableHead;
